"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForceUpdate = exports.createMemoHook = void 0;
const react_1 = require("react");
const equality_functions_1 = require("./equality-functions");
exports.createMemoHook = (areDepsEqual = equality_functions_1.depsShallowEquality) => {
    const initialResultInfo = {
        called: false,
    };
    return (fn, deps) => {
        const resultRef = react_1.useRef(initialResultInfo);
        const depsRef = react_1.useRef(deps);
        if (!resultRef.current.called) {
            resultRef.current = {
                called: true,
                data: fn(),
            };
            return resultRef.current.data;
        }
        const prevDeps = depsRef.current;
        const haveDepsChanged = !areDepsEqual(prevDeps, deps);
        if (haveDepsChanged) {
            // deps have changed; recalculating output;
            resultRef.current = {
                called: true,
                data: fn(),
            };
            depsRef.current = deps;
        }
        return resultRef.current.data;
    };
};
exports.useForceUpdate = () => {
    const [, forceUpdate] = react_1.useReducer(x => x + 1, 0);
    return forceUpdate;
};
